import Notice from '@/views/notice'
import Announce from '@/views/notice/document/announce'
import Guide from '@/views/notice/document/guide'
import Article from '@/views/notice/document/article'

export default {
  path: '/notice',
  component: Notice,
  children: [
    { path: '/notice/announce', component: Announce },
    { path: '/notice/guide', component: Guide },
    { path: '/notice/article', name: 'article', component: Article }
  ]
}
